import { gql } from '@apollo/client';

export const SaasEscrowBaseFields = gql`
  fragment SaasEscrowBaseFields on SaasEscrow {
    id
    changesRequested
    agreement {
      id
      agreementForm
      approved
    }
    escrowInvitation {
      id
      status
      partyType
      companyName
      escrow {
        id
      }
      policy {
        accept
      }
    }
    escrowTermination {
      status
      terminateAt
    }
    status
    beneficiary {
      id
      companyName
      companyWebsite
    }
    depositor {
      id
      companyName
      companyWebsite
    }
    policy {
      remove
    }
    createdAt
    adminReviewAt
    onboardingAt
    signedAt
    activatedAt
    certificationVerified
    certificationCertified
    userUpdatedAt
    pendingActivation
    lastDeposit
  }
`;

export const SaasEscrowPolicyFields = gql`
  fragment SaasEscrowPolicyFields on SoftwareEscrowPolicy {
    activate
    createAgreementSuggestedChange
    createBeneficiary
    createBeneficiarySuggestedChange
    createDepositorSuggestedChange
    createDepositSuggestedChange
    createNotificationSuggestedChange
    deferActivation
    depositAssets
    enableReports
    inviteBeneficiary
    inviteDepositor
    read
    remove
    requestTermination
    update
    updateBeneficiaryNotifications
    updateDepositorNotifications
    write
  }
`;
